// مفردات وحدة تلخيص الكتب — مصدر واحد تقرؤه القائمة والتفصيل والتقرير.
// النصوص العربية للحالات تأتي أيضاً من /book-summaries/meta، وهذه الخريطة
// تخدم التصيير الفوري قبل وصول meta وتضبط ألوان الشارات وترتيب المراحل.

export const STAGE_ORDER = [
  'draft', 'summarizing', 'under_review', 'revising', 'awaiting_approval', 'approved', 'cancelled',
];

export const STAGE_AR = {
  draft: 'مسوَّدة',
  summarizing: 'قيد التلخيص',
  under_review: 'قيد المراجعة',
  revising: 'قيد تعديل الملاحظات',
  awaiting_approval: 'بانتظار الاعتماد',
  approved: 'معتمد',
  cancelled: 'ملغى',
};

// لاحقات badge-* الموجودة في App.css — لا كلاسات جديدة
export const STAGE_BADGE = {
  draft: 'pending',
  summarizing: 'in_progress',
  under_review: 'waiting_approval',
  revising: 'revision',
  awaiting_approval: 'waiting_approval',
  approved: 'completed',
  cancelled: 'cancelled',
};

/** المراحل التي يمرّ بها الملف فعلاً — بلا المسوَّدة والملغى */
export const PIPELINE = ['summarizing', 'under_review', 'revising', 'awaiting_approval'];

export const NOTE_STATUS_AR = {
  new: 'جديد',
  revised: 'عُدِّل',
  accepted: 'مقبول',
  pending: 'معلّق',
};

export const NOTE_STATUS_BADGE = {
  new: 'pending',
  revised: 'in_progress',
  accepted: 'completed',
  pending: 'revision',
};

export const KIND_AR = {
  source: 'الكتاب المصدر',
  researcher: 'نسخة الباحث',
  reviewer: 'نسخة المراجع',
  final: 'النسخة النهائية',
  pending_notes: 'ملف الملاحظات المعلّقة',
};

/**
 * الإجراء الوحيد المتاح في هذه المرحلة.
 *
 * زرّ واحد لا خمسة: يمنع التخطّي بصرياً قبل أن يمنعه الخادم. و`can` تُقاس
 * بالصلاحية لا بالهوية — لو قِيست بالهوية لانكسر تدفّق المُشغّل الواحد لحظة
 * تكليفه كتاباً لغيره.
 */
export function stageAction(status, abilities = {}) {
  switch (status) {
    case 'draft':
      return abilities.manage
        ? { key: 'assign', label: 'تكليف باحث', icon: '👤' }
        : null;
    case 'summarizing':
      return abilities.summarize
        ? { key: 'submit-summary', label: 'تسليم للمراجعة', icon: '📤' }
        : null;
    case 'under_review':
      return abilities.review
        ? { key: 'submit-review', label: 'تسليم نتيجة المراجعة', icon: '📝' }
        : null;
    case 'revising':
      return abilities.summarize
        ? { key: 'submit-revision', label: 'تسليم للاعتماد', icon: '📤' }
        : null;
    case 'awaiting_approval':
      return abilities.approve
        ? { key: 'approve', label: 'اعتماد نهائي', icon: '✅' }
        : null;
    default:
      return null;
  }
}

/** من يملك رفع كل نوع نسخة في المرحلة الحالية */
export function canUpload(kind, status, abilities = {}) {
  if (abilities.manage) return true;
  if (kind === 'researcher') return !!abilities.summarize && ['summarizing', 'revising'].includes(status);
  if (kind === 'reviewer') return !!abilities.review && status === 'under_review';
  return false;
}
